import { render, staticRenderFns } from "./CopyOffersSection.vue?vue&type=template&id=5efebd59"
import script from "./CopyOffersSection.vue?vue&type=script&lang=js"
export * from "./CopyOffersSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports